import request from '@/utils/request'

/**
 * 获取订正分析的查询选项数据
 * @returns {Promise}
 */
export function getCorrectionAnalysisOptions() {
  return request({
    url: '/api/correction-analysis/options',
    method: 'get'
  })
}

/**
 * 获取订正分析数据
 * @param {Object} params - 查询参数
 * @param {Array} params.tagNames - 题目标签数组
 * @param {Array} params.questionLevels - 题目难度数组
 * @param {Array} params.correctionStatus - 订正状态数组
 * @param {Array} params.dateRange - 日期范围数组
 * @param {String} params.chartType - 图表类型 (tag/time)
 * @returns {Promise}
 */
export function getCorrectionAnalysisData(params) {
  return request({
    url: '/api/correction-analysis/data',
    method: 'get',
    params
  })
}
